import {createAction} from 'redux-actions';

import ActionTypes from './action-types';

export default {
    fetchAllSuccess: createAction(ActionTypes.AREA_FETCH_ALL_SUCCESS, (areas, organizationId) => ({
        areas,
        organizationId,
    })),

    create: createAction(ActionTypes.AREA_CREATE, area => ({area})),
    createFailed: createAction(ActionTypes.AREA_CREATE_FAILED),
    createSuccess: createAction(ActionTypes.AREA_CREATE_SUCCESS, area => ({area})),

    addInstitution: createAction(ActionTypes.AREA_ADD_INSTITUTION, (areaId, institutionId) => ({
        areaId,
        institutionId,
    })),
    addInstitutionFailed: createAction(ActionTypes.AREA_ADD_INSTITUTION_FAILED),
    addInstitutionSuccess: createAction(ActionTypes.AREA_ADD_INSTITUTION_SUCCESS, area => ({area})),
    removeInstitution: createAction(ActionTypes.AREA_REMOVE_INSTITUTION, (areaId, institutionId) => ({
        areaId,
        institutionId,
    })),
    removeInstitutionFailed: createAction(ActionTypes.AREA_REMOVE_INSTITUTION_FAILED),
    removeInstitutionSuccess: createAction(ActionTypes.AREA_REMOVE_INSTITUTION_SUCCESS, area => ({area})),
};
